import { useTheme } from '@emotion/react';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { DOWNLOAD_FILE } from 'framework/base/constants/aryRestCommands';
import useAryGetData, {
  aryGetDataExpectTypes
} from 'framework/base/hooks/useAryGetData';
import React from 'react';
import { imageAddressPrefix } from 'spec';
import ActionButtons from './ActionButtons';
import { DownloadIcon, DownloadIconWrapper } from './StyledComponents';

export default function AryMobileUploadedFileItem({
  preview,
  onShowPreview,
  previews,
  updatePreviewsAfterFileDownloaded,
  files,
  prevFiles,
  propsFileIds,
  handleRemovedFileIds,
  removedFileIds,
  onChange,
  setPreviews,
  setPrevFiles,
  handleSavedFileIds,
  handleSetDisabledDropzone
}) {
  const theme = useTheme();

  const [downloadFile, { loading: downloadFileLoading }] = useAryGetData(
    DOWNLOAD_FILE,
    {
      expect: aryGetDataExpectTypes.file
    }
  );

  const actionIconWrapperSx = {
    width: '2rem',
    height: '2rem',
    bgcolor: theme.footer.background,
    padding: 1,
    border: `1px solid ${theme.icon.disable.color}`
  };
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      gap={3}
      bgcolor={theme.wrapper.background.default}
      px={4}
      py={3}
      borderRadius="0.375rem"
      onClick={(event) => event.stopPropagation()}
    >
      <Grid>
        <ActionButtons
          preview={preview}
          previews={previews}
          files={files}
          prevFiles={prevFiles}
          propsFileIds={propsFileIds}
          removedFileIds={removedFileIds}
          handleRemovedFileIds={handleRemovedFileIds}
          onChange={onChange}
          setPreviews={setPreviews}
          setPrevFiles={setPrevFiles}
          handleSavedFileIds={handleSavedFileIds}
          iconSx={actionIconWrapperSx}
          iconColor={theme.palette.secondary.main}
          handleSetDisabledDropzone={handleSetDisabledDropzone}
        />
      </Grid>
      <Grid display="flex" alignItems="center" gap={2}>
        <Typography
          dir="ltr"
          variant="c3Bold"
          noWrap
          width="15rem"
          textOverflow="ellipsis  [..]"
          display="inline-block"
        >
          {preview.name}
        </Typography>
        <Box
          key={preview.name}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <Grid
            onMouseUp={() => {
              if (!preview.downloaded) return;
              if (
                preview.imgSrc === 'pdf' ||
                preview.imgSrc === 'docx' ||
                preview.imgSrc === 'xlsx'
              ) {
                return;
              }
              onShowPreview(preview);
            }}
          >
            {preview.downloaded ? (
              <Grid
                width="2.5rem"
                height="2.5rem"
                borderRadius={1}
                overflow="hidden"
              >
                <img
                  width="100%"
                  height="100%"
                  src={
                    preview.imgSrc === 'pdf' || preview.filePreview === 'pdf'
                      ? `${imageAddressPrefix}static/img/icons/pdf.png`
                      : preview.imgSrc === 'docx'
                      ? `${imageAddressPrefix}static/img/icons/word.png`
                      : preview.imgSrc === 'xlsx'
                      ? `${imageAddressPrefix}static/img/icons/excel.png`
                      : preview.imgSrc
                  }
                  alt="file preview"
                />
              </Grid>
            ) : downloadFileLoading ? (
              <CircularProgress size={20} />
            ) : (
              <DownloadIconWrapper
                onMouseUp={() => {
                  downloadFile([{ key: 'fileId', value: preview.fileId }]).then(
                    (downloadFileData) => {
                      updatePreviewsAfterFileDownloaded(
                        preview,
                        downloadFileData
                      );
                    }
                  );
                }}
              >
                <DownloadIcon />
              </DownloadIconWrapper>
            )}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}
